import { get } from 'lodash';
import validation from '../../../scripts/services/validation';
import { trackPayButtonClick, trackOtherPaymentMethodClick, trackPayAsLegalClick } from './PayByCardModal.tracking';
import { getTitle, getSubmitText, getSum } from './utils';
import { depositAmountWidget } from '../../../../../shared/services/billingAccounts/depositAmountWidget';
import { plural } from '@cian/utils';
import { selectBillingProblemReasons } from '../../../../../shared/selectors/billingStatus';
import { selectAnalyticsOfferStatus } from '../../../../../shared/selectors/analytics';
import './pay-by-card.css';
import { selectTotalAmount } from '../../../../../shared/selectors/checkoutInfo';
import { selectBalance } from '../../../../../shared/selectors/user';
import { selectMainPaymentProvider } from '../../../../../shared/selectors/paymentProviders';
import { EPaymentProvider } from '../../../../../shared/types/reducers/paymentProviders';
import { getCloudPaymentsWidgetData } from '../../../../../shared/services/billingAccounts/getCloudPaymentsWidgetData';
import { EPaymentInitSource } from '../../../../../shared/services/billingAccounts/depositAmountWidget/types';

export default [
  '$rootScope',
  '$scope',
  'options',
  'placingTermsApi',
  '$uibModalInstance',
  'publishTermsService',
  'cardPaymentService',
  'homeownerService',
  'telemetryService',
  'httpApi',
  'config',
  'deviceService',
  'store',
  function (
    $rootScope,
    $scope,
    options,
    placingTermsApi,
    $uibModalInstance,
    publishTermsService,
    cardPaymentService,
    homeownerService,
    telemetryService,
    httpApi,
    config,
    deviceService,
    store,
  ) {
    const maxPaymentAmount = config.getStrict('maxPaymentAmount');

    const state = store.getState();
    const { source, amount } = options;
    const analyticsOfferStatus = selectAnalyticsOfferStatus(state);
    const billingProblemReasons = selectBillingProblemReasons(state);
    const provider = selectMainPaymentProvider(state);
    const balance = selectBalance(state);

    const totalAmount = publishTermsService.isNewPublishTermsEnabled()
      ? selectTotalAmount(state).price
      : placingTermsApi.getTotalPriceAmount();

    cardPaymentService.resetState();

    $scope.isMobile = deviceService.isMobile;
    $scope.title = getTitle(source);
    $scope.submitText = getSubmitText(source);
    this.sum = getSum({
      source,
      amount,
      totalAmount,
      balance,
    });

    $scope.isAccountTypeUndefined = get($rootScope, 'user.billingInfo.accountType') === undefined;
    $scope.maxPaymentAmount = maxPaymentAmount;

    $scope.billingProblemReason = billingProblemReasons.deposit;

    const sumValidationMessages = {
      parse: 'Введите сумму платежа',
      min: 'Минимальная сумма платежа – 1 рубль',
      max: `Максимальная сумма платежа – ${maxPaymentAmount} ${plural(maxPaymentAmount, ['рубль', 'рубля', 'рублей'])}`,
      required: 'Не указана сумма платежа',
    };

    $scope.$watch('form', () => {
      $scope.validation = validation(this.form, 'sum', sumValidationMessages);
    });

    $scope.isVisibleOtherPayMethods = () => {
      return homeownerService.userType !== 'homeowner';
    };

    $scope.trackOtherPaymentMethodClick = trackOtherPaymentMethodClick(source, analyticsOfferStatus);
    $scope.trackPayAsLegalClick = trackPayAsLegalClick(source, analyticsOfferStatus);

    $scope.handleSubmit = async () => {
      if (!this.form.$valid) {
        return;
      }

      trackPayButtonClick({ source, recommendedSum: this.sum, offerStatus: analyticsOfferStatus });

      cardPaymentService.setPaymentSum(this.sum);

      $scope.isPending = true;

      if (provider === EPaymentProvider.YooKassa) {
        const confirmationToken = await depositAmountWidget({
          httpApi,
          amount: this.sum,
          paymentInitSource: EPaymentInitSource.AddFormDeposit,
        });

        telemetryService.increment('yoo-money-widget.init');

        var checkout = new window.YooMoneyCheckoutWidget({
          confirmation_token: confirmationToken,
          error_callback: () => {
            telemetryService.increment('yoo-money-widget.fail');
          },
          customization: {
            modal: true,
          },
        });

        checkout.on('success', () => {
          const paymentId = confirmationToken.substring(3);

          cardPaymentService.setPaymentProcessed(true);
          cardPaymentService.runCheckPaymentState(paymentId);

          checkout.destroy();
        });

        checkout.render();
      } else if (provider === EPaymentProvider.CloudPayments) {
        const baseWidgetParams = await getCloudPaymentsWidgetData({ httpApi, amount: this.sum });

        telemetryService.increment('cloud-payments-widget.init');

        try {
          const widgetParams = {
            ...baseWidgetParams,
            amount: Number(this.sum),
            currency: 'RUB',
            skin: 'mini',
          };

          const onSuccess = () => {
            cardPaymentService.setPaymentProcessed(true);
            cardPaymentService.runCheckPaymentState(widgetParams.invoiceId);
          };

          const widgetCallbacks = {
            onSuccess,
          };

          const widget = new window.cp.CloudPayments();
          widget.pay('charge', widgetParams, widgetCallbacks);
        } catch (_) {
          telemetryService.increment('cloud-payments-widget.fail');
        }
      }

      $uibModalInstance.close('payByCard');
    };
  },
];
